export default "__VITE_ASSET__CNDjgb9P__"